exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".v-dialog.v-modal-factory-fullscreen{margin:0;max-height:100%}", "", {"version":3,"sources":["D:/A32/Atlant/dealger_spring_1/client/src/components/common/ModalFactory.vue"],"names":[],"mappings":"AACA,qCACE,SAAU,AACV,eAAiB,CAClB","file":"ModalFactory.vue","sourcesContent":["\n.v-dialog.v-modal-factory-fullscreen {\n  margin: 0;\n  max-height: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a877419","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/ModalFactory.vue
// module id = 976
// module chunks = 1